import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL, fetchJson, readStoredUser, refreshStoredUser } from '../../utils/auth';

export default function PirateCustom() {
  const [resolvedRole, setResolvedRole] = useState('viewer');
  const navigate = useNavigate();
  const apiUrl = encodeURIComponent(API_URL);

  useEffect(() => {
    let ignore = false;
    const storedUser = readStoredUser();

    if (!storedUser) {
      setResolvedRole('viewer');
      return () => {
        ignore = true;
      };
    }

    async function refreshCurrentUserRole() {
      try {
        const refreshedUser = await refreshStoredUser();

        if (!ignore && refreshedUser) {
          const { response, payload } = await fetchJson('/pirate-system/access', {
            method: 'GET',
          });

          if (!ignore && response.ok) {
            setResolvedRole(payload.access?.role || 'viewer');
            return;
          }

          if (!ignore) {
            setResolvedRole(refreshedUser.role === 'owner' ? 'owner' : 'viewer');
          }
        }
      } catch (_error) {
        if (!ignore) {
          setResolvedRole(readStoredUser()?.role === 'owner' ? 'owner' : 'viewer');
        }
      }
    }

    refreshCurrentUserRole();

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100dvh',
        overflow: 'hidden',
      }}
    >
      <button
        type="button"
        onClick={() => navigate('/projects/Pirate')}
        style={{
          position: 'absolute',
          top: '8px',
          left: '12px',
          zIndex: 1000,
          minWidth: '104px',
          padding: '9px 14px',
          border: '1px solid rgba(217, 187, 121, 0.45)',
          borderRadius: '6px',
          background: 'rgba(47, 36, 23, 0.92)',
          color: '#f6edd7',
          cursor: 'pointer',
          fontFamily: '"Trebuchet MS", sans-serif',
          fontSize: '0.92rem',
          fontWeight: 700,
          boxSizing: 'border-box',
          boxShadow: '0 8px 20px rgba(47, 36, 23, 0.18)',
        }}
      >
        &lt; Back
      </button>

      <iframe
        src={`/games/PirateSystem/PirateHomebrewBuilder.html?role=${encodeURIComponent(resolvedRole)}&apiUrl=${apiUrl}`}
        title="Pirate Homebrew Builder"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
}
